import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { eur } from "@/components/excelVoce/format";
import { ConfrontoCards } from "./ConfrontoCards";
import { EsecutoriMdo } from "./EsecutoriMdo";
import { RegistroLista } from "./RegistroLista";
import { StoricoDialog } from "./StoricoDialog";
import { TIPO_LABEL } from "./labels";

export const RegistroVoce = ({ data, um, canEdit, onNew, onEdit, reload }) => {
  const [storico, setStorico] = useState(null);
  if (!data) return <div className="text-slate-500 p-4">Caricamento registro…</div>;
  const fa = data.fuori_analisi || {};
  return (
    <Card data-testid="excel-registrazioni-effettive"><CardContent className="p-4 sm:p-6 space-y-4">
      <div className="flex flex-wrap items-start gap-3">
        <div className="mr-auto">
          <div className="text-xs uppercase tracking-widest text-sky-700 font-semibold">Registrazioni effettive</div>
          <p className="text-sm text-slate-500 mt-1 max-w-2xl">Registro unico condiviso con Materiali, Manodopera e Controllo costi. È separato dall'analisi prevista, che non viene mai modificata.</p>
        </div>
        {canEdit && ["MATERIALE", "MANODOPERA", "NOLO"].map((t) => (
          <Button key={t} size="sm" variant="outline" onClick={() => onNew(t)} data-testid={`voce-nuova-${t}`}><Plus className="h-3.5 w-3.5 mr-1" /> {TIPO_LABEL[t]}</Button>
        ))}
      </div>
      <ConfrontoCards confronto={data.confronto} testid="voce-confronto" />
      {(Number(fa.MATERIALE) || Number(fa.MANODOPERA) || Number(fa.NOLO)) ? (
        <p className="text-xs text-slate-500" data-testid="voce-fuori-analisi">Di cui su risorse non presenti nell'analisi: materiali {eur(fa.MATERIALE)} · manodopera {eur(fa.MANODOPERA)} · noli {eur(fa.NOLO)}</p>
      ) : null}
      <EsecutoriMdo rigaId={data.riga_id} esecutori={data.esecutori_mdo} um={um} canEdit={canEdit} onChanged={reload} />
      <RegistroLista regs={data.registrazioni} canEdit={canEdit} onEdit={onEdit} onStorico={setStorico} onChanged={reload} highlightRigaId={data.riga_id} testid="voce-registro-lista" />
      <StoricoDialog regId={storico} onOpenChange={() => setStorico(null)} />
    </CardContent></Card>
  );
};
